<template>
  <v-container fluid py-0>
    <v-row justify="end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mr-3 mb-3"
            v-on="on"
            small
            fab
            dark
            color="primary"
            @click="onUpload"
            :loading="uploading"
          >
            <v-icon dark>add</v-icon>
          </v-btn>
        </template>
        <span>Add new Attachment</span>
      </v-tooltip>
      <input
        ref="fileChooser"
        accept=".pdf,.doc,.docx,.xls,.jpg,.jpeg,.png"
        type="file"
        style="display: none"
        @change="onFileChange"
      />
    </v-row>
    <v-card outlined>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.createdAt="{ item }">{{
          item.createdAt | formatDate
        }}</template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small @click="onDownload(item)">
            <v-icon small color="primary">mdi-download</v-icon>
          </v-btn>
          <v-btn icon small @click="onDelete(item)">
            <v-icon small color="pink">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-row v-if="debug">
      <code>
        {{ selectedAttachment }}
      </code>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { SIGNED_URL_QUERY } from "../../../../constants/graphql";
import { removeGQLTypename } from "../../../../helpers";
const CREATE_ATTACHMENT_MUTATION = gql`
  mutation createAttachment($input: AttachmentInput) {
    createAttachment(input: $input) {
      id
      name
      url
      createdAt
    }
  }
`;
const UPDATE_ATTACHMENT_MUTATION = gql`
  mutation updateAttachment($input: AttachmentInput) {
    updateAttachment(input: $input) {
      id
      name
      url
      createdAt
    }
  }
`;
const ATTACHMENTS_QUERY = gql`
  query attachments($filter: AttachmentFilterType) {
    attachments(filter: $filter) {
      edges {
        node {
          id
          name
          createdAt
          owner
          url
        }
      }
    }
  }
`;
const DELETE_ATTACHMENT_MUTATION = gql`
  mutation deleteAttachment($id: ID!) {
    deleteAttachment(id: $id) {
      id
    }
  }
`;

export default {
  name: "attachments",
  props: {
    ownerId: {
      type: String,
      required: true,
      default: () => "",
    },
    ownerType: {
      type: String,
      required: true,
      default: () => "",
    },
  },
  data() {
    return {
      debug: false,
      headers: [
        { text: "Created At", value: "createdAt" },
        { text: "Name", value: "name" },
        { text: "Actions", value: "actions" },
      ],
      uploading: false,
      selectedAttachment: null,
    };
  },

  computed: {
    items() {
      return this.attachments && this.attachments.edges
        ? this.attachments.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onUpload() {
      this.$refs.fileChooser.click();
    },
    onFileChange(event) {
      if (this.$refs.fileChooser.files.length > 0) {
        this.uploading = true;
        this.selectedAttachment = this.$refs.fileChooser.files[0];
        this.$apollo
          .query({
            query: SIGNED_URL_QUERY,
            variables: {
              fileName: this.selectedAttachment.name,
            },
          })
          .then(this.putAttachmentToTheBucket, this.handleAttachmentError);
      }
    },
    putAttachmentToTheBucket(result) {
      const response = { ...result.data.signedUrl };
      console.log("result", result);
      console.log("response", response);
      if (response.url) {
        fetch(response.url, {
          method: "PUT",
          body: this.selectedAttachment,
        }).then(this.saveAttachment, this.handleAttachmentError);
      } else {
        this.handleAttachmentError({ message: "Cannot upload the file!" });
      }
    },
    handleAttachmentError(error) {
      this.uploading = false;
      this.$store.dispatch("showAppSnackbar", {
        msg: error.message,
        color: "danger",
      });
    },
    saveAttachment(result) {
      console.log("saveAttachment result", result);
      this.uploading = false;
      const input = {
        ownerId: this.ownerId,
        owner: this.ownerType,
        name: this.selectedAttachment.name,
        url: result.url,
      };
      this.$apollo
        .mutate({
          mutation: CREATE_ATTACHMENT_MUTATION,
          variables: { input },
          refetchQueries: [
            {
              query: ATTACHMENTS_QUERY,
              variables: {
                filter: {
                  ownerId_eq: this.ownerId,
                  owner_eq: this.ownerType,
                },
              },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Attachment saved successfully",
            color: "success",
          });
        })
        .catch((error) => {
          console.error("error", error);
          this.$store.dispatch("showAppSnackbar", {
            msg: error.message,
            color: "danger",
          });
        });
    },
    onDelete(item) {
      this.$apollo
        .mutate({
          mutation: DELETE_ATTACHMENT_MUTATION,
          variables: { id: item.id },
          refetchQueries: [
            {
              query: ATTACHMENTS_QUERY,
              variables: {
                filter: {
                  ownerId_eq: this.ownerId,
                  owner_eq: this.ownerType,
                },
              },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Attachment deleted successfully",
            color: "success",
          });
        })
        .catch((error) => {
          console.error("error", error);
          this.$store.dispatch("showAppSnackbar", {
            msg: error.message,
            color: "danger",
          });
        });
    },
    onDownload(item) {
      window.open(item.url, "_blank");
    },
  },
  apollo: {
    attachments: {
      query: ATTACHMENTS_QUERY,
      variables() {
        return {
          filter: {
            ownerId_eq: this.ownerId,
            owner_eq: this.ownerType,
          },
        };
      },
      skip() {
        return this.ownerId == "" || this.ownerType == "";
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/gt/shared/attachments/Attachments.vue